<template>
  <div>
    <el-dialog title="导航设置" :visible.sync="menuVisible" width="800px">
      <el-row type="flex" justify="space-between" class="mb15">
        <el-col :span="1"> </el-col>
      </el-row>

      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        class="menuTable"
        tooltip-effect="dark"
        :data="menuList"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column prop="title" label="导航名称"></el-table-column>
        <el-table-column prop="linkUrl" label="链接地址"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="enabled"
          label="状态"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-if="scope.row.foreverExist != 1"
              v-model="scope.row.enabled"
              :active-value="1"
              :inactive-value="-1"
              @change="updateSwitching(scope.row)"
              class="switchStyle"
            ></el-switch>
            <div v-else>展示</div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--新增编辑弹框-->
    <el-dialog :title="popType" :visible.sync="dialogVisible" width="40%">
      <el-form
        :model="ruleForm"
        :rules="rules"
        style="width: 70%"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="导航类型">
          <el-radio-group v-model="ruleForm.type">
            <el-radio :label="1">路由</el-radio>
            <el-radio :label="2">外链接地址</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="导航名称" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="链接地址" prop="linkUrl">
          <el-input v-model="ruleForm.linkUrl"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="ruleForm.sort" type="number"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUrlSure('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menuVisible: false,
      ids: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      menuList: [],
      loading: false,
      dialogVisible: false,
      popType: "",
      ruleForm: {
        type: 1,
        linkUrl: "",
        title: "",
        sort: 0,
        name: "",
        id: "",
        schoolPageTemplateId: "",
      },
      rules: {
        title: [{ required: true, message: "请输入导航名称", trigger: "blur" }],
        linkUrl: [
          { required: true, message: "请输入链接地址", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    menuVisible(val) {
      if (val) {
        this.pageList();
      } else {
        this.$store.dispatch("design/getMenu");
      }
    },
  },
  methods: {
    pageList() {
      this.api.wxSchoolPageMenu
        .getWxSchoolPageMenuList({
          schoolPageTemplateId: this.ruleForm.schoolPageTemplateId,
        })
        .then((result) => {
          this.menuList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    updateSwitching(row) {
      this.api.wxSchoolPageMenu
        .enabled({
          id: row.id,
          enabled: row.enabled,
        })
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message,
            });
            this.pageList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.ruleForm.schoolPageTemplateId = this.$route.query.id;
  },
};
</script>


// WEBPACK FOOTER //
// src/components/designPage/components/menuDialog.vue